import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FlashService } from './flash.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

    constructor(private http: HttpClient, private flashService: FlashService) { }

    GetReportInfo(appId, appOptId) {
        return this.http.get('/api/Report/ReportBaseInformation', {
            params: {
                appId: appId,
                appOptId: appOptId
            }
        }).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetReport(data) {
        return this.http.post('/api/Report/Report', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    SavePreferences(data) {
        return this.http.post('/api/Report/SaveReportColumnPreferences', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetReportFilters(reportId) {
        return this.http.get('/api/Report/ReportFilters?reportId=' + reportId).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    GetStoredReportFilterSets(reportId) {
    	return this.http.get('/api/Report/GetStoredReportFilterSets?reportId=' + reportId).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    ReportFilterSetAction(data) {
      return this.http.post('/api/Report/ReportFilterSetAction', data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }
    private handleSuccess(res) {
        return { success: true, data: res };
    }

    private handleError(res) {
        this.flashService.Error(res.error.errors.toString(), false);
        return { success: false };
    }
}
